import React from "react";
import { Layout } from "antd";
import ContentSiderWrapper from "./ContentSider.style";
const { Sider } = Layout;

const ContentSider = (props) => {
  const { children, width } = props;
  return (
    <ContentSiderWrapper>
      <Sider width={width}>{children}</Sider>
    </ContentSiderWrapper>
  );
};

export default ContentSider;
